module.exports = __webpack_public_path__ + "static/media/ic-social-twitter.b229c069.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-social-twitter.svg
// module id = 671
// module chunks = 14